import { render } from "./InventoryRestockOriginalDetail.vue?vue&type=template&id=a509d9d8&scoped=true"
import script from "./InventoryRestockOriginalDetail.vue?vue&type=script&lang=js"
export * from "./InventoryRestockOriginalDetail.vue?vue&type=script&lang=js"

import "./InventoryRestockOriginalDetail.vue?vue&type=style&index=0&id=a509d9d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a509d9d8"]])

export default __exports__